export default {"src":"/_next/static/media/text-instruction-one.578a8bd7.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};